module.exports = __webpack_public_path__ + "static/media/AdminIconWhite.5101d373.png";